module.exports = __webpack_public_path__ + "static/media/confirm.840a264d.svg";